module.exports = __webpack_public_path__ + "img/cancel_refund.0b7ec7d6.png";